import { ThunkDispatch } from "core-integration/src/store";
import { updateElementControls } from "core-integration/src/store/elements/actions";
import { getElementControls } from "core-integration/src/store/elements/reducers";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { SearchField } from "../../FieldRenderers";

const ElementSearchField = () => {
  const { t } = useTranslation();
  const controls = useSelector(getElementControls);
  const dispatch = useDispatch<ThunkDispatch>();

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(updateElementControls({ ...controls, search: e.target.value }));
  };

  return (
    <SearchField
      id="search"
      name="search"
      label={t("elementList.search", "Search Player List")}
      labelVisibility={false}
      placeholder={t("elementList.search", "Search Player List") as string}
      onChange={handleSearchChange}
      value={controls.search}
    />
  );
};

export default ElementSearchField;
